module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_17.png?8b01934d8e7ae2eb3fd07bc51852d2e4";